import { Authority, Feature } from '../account/Types';
import { AdminState } from '../admin/admin.types';
import { AuthState } from '../auth/auth.types';
import {
  NONE,
  READ,
  CREATE,
  UPDATE,
  CALENDAR,
  ATTENDANCE,
  PROGRAM,
  PAYMENT,
  FULL,
  ACCOUNT,
  CLIENT,
  STAFF,
  MEMBER,
  POS,
  PACKAGE,
  MARKETING
} from '../account/Constants';

export const NOT_ENOUGH_PERMISSION_IMAGE = require('../img/not_enough_permission.jpg');
const DEFAULT_IMPERSONATION_ACCOUNT_ID = 0;

export const filterFeature = (
  feature: Feature, authState: AuthState, adminState: AdminState
): Authority | undefined => {
  if (adminState.impersonation && adminState.impersonation.account.id !== DEFAULT_IMPERSONATION_ACCOUNT_ID) {
    return adminState.impersonation.account.authorities.find((a: Authority) => a.feature === feature);
  } else {
    return authState.account ?
      authState.account.authorities.find((a: Authority) => a.feature === feature) :
      undefined;
  }
};

export const isProgramDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(PROGRAM, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isPackageDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(PACKAGE, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isPaymentDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(PAYMENT, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isMemberDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(MEMBER, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isAttendancesDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(ATTENDANCE, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isCalendarDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(CALENDAR, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isAccountDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(ACCOUNT, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isPosDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(POS, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isPosRead = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(POS, authState, adminState);
  return maybe ? maybe.permission === READ : false;
};

export const isPosCreate = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(POS, authState, adminState);
  return maybe ? maybe.permission === CREATE : false;
};

export const isPosFull = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(POS, authState, adminState);
  return maybe ? maybe.permission === FULL : false;
};

export const isPosUpdate = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(POS, authState, adminState);
  return maybe ? maybe.permission === UPDATE : false;
};

export const isMarketingCreate = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(MARKETING, authState, adminState);
  return maybe ? maybe.permission === CREATE : false;
};

export const isMarketingFull = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(MARKETING, authState, adminState);
  return maybe ? maybe.permission === FULL : false;
};

export const isMarketingUpdate = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(MARKETING, authState, adminState);
  return maybe ? maybe.permission === UPDATE : false;
};

export const isMarketingDisabled = (authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(MARKETING, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const isItClientAccount = (authState: AuthState, adminState: AdminState): boolean => {
  if (adminState.impersonation && adminState.impersonation.account.id !== DEFAULT_IMPERSONATION_ACCOUNT_ID) {
    return adminState.impersonation.account.accountType === CLIENT;
  } else {
    return authState.account ? authState.account.accountType === CLIENT : false;
  }
};

export const isItStaffAccount = (authState: AuthState, adminState: AdminState): boolean => {
  if (adminState.impersonation && adminState.impersonation.account.id !== DEFAULT_IMPERSONATION_ACCOUNT_ID) {
    return adminState.impersonation.account.accountType === STAFF;
  } else {
    return authState.account ? authState.account.accountType === STAFF : false;
  }
};

export const cannotRead = (feature: Feature, authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(feature, authState, adminState);
  return maybe ? maybe.permission === NONE : true;
};

export const cannotWrite = (feature: Feature, authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(feature, authState, adminState);
  return maybe ? maybe.permission !== CREATE && maybe.permission !== FULL : true;
};

export const cannotUpdate = (feature: Feature, authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(feature, authState, adminState);
  return maybe ? maybe.permission !== UPDATE && maybe.permission !== CREATE &&
    maybe.permission !== FULL : true;
};

export const cannotDelete = (feature: Feature, authState: AuthState, adminState: AdminState): boolean => {
  const maybe = filterFeature(feature, authState, adminState);
  return maybe ? maybe.permission !== FULL : true;
};


// WEBPACK FOOTER //
// ./src/util/permission.util.tsx